<div class="sign-event-container">
  <div class="sign-event-message" *ngIf="!regenerating; else regeneratingTpl" [ngSwitch]="outcome">

    <ng-container *ngSwitchCase="'signed'">
      <div class="success-icon">
        <img src="assets/icons/done-ring.svg" alt="Success" />
      </div>
      <h2>Contrat de mise à disposition signé</h2>
    </ng-container>

    <ng-container *ngSwitchCase="'expired'">
      <h2>⏱️ Session de signature expirée</h2>
      <p *ngIf="!regenerateError">Préparation d'un nouveau lien de signature…</p>
      <p *ngIf="regenerateError">Impossible de générer un nouveau lien automatiquement. Veuillez recommencer la signature.</p>
    </ng-container>

    <ng-container *ngSwitchCase="'cancelled'">
      <h2>Signature annulée</h2>
      <p>La signature a été annulée. Vous pourrez la reprendre plus tard.</p>
    </ng-container>

    <ng-container *ngSwitchCase="'declined'">
      <h2>Signature refusée</h2>
      <p>Vous avez refusé de signer le contrat de mise à disposition.</p>
    </ng-container>

    <ng-container *ngSwitchCase="'failed'">
      <h2>Échec de la signature</h2>
      <p>Une erreur est survenue. Veuillez réessayer plus tard.</p>
    </ng-container>

    <ng-container *ngSwitchDefault>
      <h2>Aucune signature enregistrée</h2>
      <p>Le contrat n'a pas été signé.</p>
    </ng-container>

  </div>

  <ng-template #regeneratingTpl>
    <div class="sign-event-message">
      <h2>Génération d'un lien…</h2>
      <p>Vous allez être redirigé vers DocuSign dans un instant.</p>
    </div>
  </ng-template>
</div>
